export default {
  title: 'Checkout',
  subtitle: 'Review your order and confirm purchase.',
  emptyTitle: 'Nothing to check out',
  emptyText: 'Your cart is empty. Add some game keys first.',
  browseCatalog: 'Browse catalog',
  billingInformation: 'Billing information',
  edit: 'Edit',
  name: 'Name',
  email: 'Email',
  country: 'Country',
  address: 'Address',
  city: 'City',
  postalCode: 'Postal Code',
  phone: 'Phone',
  walletBalance: 'Wallet balance',
  chargedFromWallet: 'this order is charged from your wallet',
  topUp: 'Top up',
  orderSummary: 'Order summary',
  subtotal: 'Subtotal',
  total: 'Total',
  insufficientBalance: 'Insufficient wallet balance — top up to cover this order.',
  placeOrder: 'Place order',
  termsAgreementPre: 'By placing this order you agree to our',
  termsAndConditions: 'Terms & Conditions',
  instantDelivery: 'Instant key delivery after payment.',
  // Processing
  processing: 'Processing',
  processingPayment: 'Processing Payment',
  processingPaymentPrefix: 'Processing',
  processingPaymentAccent: 'Payment',
  processingText: "We're confirming your transaction with the payment provider. This usually takes a few seconds.",
  reference: 'Reference: {ref}',
  doNotClose: 'Please do not close this window or refresh the page.',
  // Failed
  failed: 'Failed',
  payment: 'Payment',
  paymentFailed: 'Failed',
  failedText: "We couldn't complete your transaction. No funds have been taken from your wallet.",
  reason: 'Reason',
  orderId: 'Order ID',
  defaultReason: 'Insufficient wallet balance',
  contactSupportText: 'If the problem persists, contact our support team.',
  tryAgain: 'Try again',
  contactSupport: 'Contact support',
  // Success
  successPrefix: 'Payment',
  successAccent: 'Successful',
  successText: 'Your order is confirmed. Game keys are ready in your Orders page, and a confirmation email is on its way.',
  itemsLabel: 'Items',
  keysNotice: 'Keys are also in your email. Do not delete until activation.',
  goToOrders: 'Go to orders',
  backToCatalog: 'Back to catalog',
};
